<template>
    <div class="banner-area banner-image horizontal" id="banner">
        <div class="container">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="banner-text">
                        <div class="banner-table-cell">
                            <h1>SOFTWARE DE <span>GESTÃO</span><br>
                            <span>EMPRESARIAL</span> ONLINE</h1>
                            <p>Faça a gestão de sua empresa ficar muito mais simples, rápida e eficiente.<br>
                            Com o {{ app.nome }} você ganha tempo para focar no seu negócio.</p>
                            <h3>EXPERIMENTE GRÁTIS POR {{ app.dias_gratis }} DIAS</h3>
                            <div class="row">
                                <div class="banner-buttons col-sm-12 col-md-8 col-lg-7">
                                    <form id = "cadastro-topo" action="/cadastro" method="get">
                                        <div class="newsletter-content">
                                            <input type="text" name="email" placeholder="Digite seu e-mail" class = "required email">
                                            <button type="submit" class="button button-olive"><span class="hidden-xs">Experimente grátis</span><span class="visible-xs">Começar</span></button>
                                        </div>
                                        <label class="error" for="email" generated="true" style="display: none; font-size:18px"></label>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['app'],
}
</script>